<template>
  <v-row>
    <v-col cols="12">
      <gg-card-title class="pt-0">
        {{ $route.meta.pageTitle }}
      </gg-card-title>
      <profile-navigation />
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
import ProfileNavigation from 'Components/Profile/ProfileNavigation'

export default {
  name: 'Profile',
  components: { ProfileNavigation }
}
</script>
